export default "__VITE_ASSET__ClHSVIKN__"